import React, { useEffect, useState } from 'react'
import MenuList from './TaskMenu';
import { Nav, NavItem, NavLink } from 'reactstrap'
import { useDispatch, useSelector } from "react-redux";
import TaskInnerLeftContent from './TaskInnerLeftContent';
import { MainBarActiveTabsAction } from '../../../../actions/MainBarActiveTabsAction';

const TaskInnerLeftMenu = (props) => {
    let dispatch = useDispatch()
    const MenuItems = MenuList();
    const AccountReceivablesCountReducer = useSelector(state => state.AccountReceivablesCountReducer);
    let activetab = useSelector(state => state.MainBarActiveTabsReducer?.TaskManagement);
    let activetabs = useSelector(state => state.MainBarActiveTabsReducer);


    console.log(activetab, 'TaskEncounter');
    console.log(activetabs, 'activetabs');



    const [subCategoryItems, setSubCategItems] = useState([]);
    const [activeTabKey, setActiveTabKey] = useState();
    const [tabsList, setTabsList] = useState([]);



    // useEffect(() => {
    //     const selected_Item_List = MenuItems.filter((item) => item.key === props.subCategKey);
    //     if (selected_Item_List && selected_Item_List.length > 0) {
    //         let subCategories = selected_Item_List[0].subCategoryItems
    //         setSubCategItems(subCategories)
    //         let active = subCategories.filter(item => item.key === activeTabKey);
    //         active[0] ? handleActiveTab(active[0]) : handleActiveTab(subCategories.filter(item => item.right === true)[0]);
    //     }
    // }, [props.subCategKey, activeTabKey])

    useEffect(() => {
        const selected_Item_List = MenuItems.filter((item) => item.key === props.subCategKey);
        if (selected_Item_List && selected_Item_List.length > 0) {
            let subCategories = selected_Item_List[0].subCategoryItems
            setSubCategItems(subCategories)
            let active = subCategories.filter(item => item.key === activetab?.ActiveTabKey);
            active[0] ? handleActiveTab(active[0], "isDispatched") : handleActiveTab(subCategories.filter(item => item.right === true)[0]);
        }
    }, [props.subCategKey, activetab])
    const handleActiveTab = (item, type) => {

        if (!item?.right) {
            return
        } else {
            const { key, name, right, component } = { ...item }
            let dynamicTabs = [...tabsList]
            const newTabObject = {
                key: key,
                name: name,
                right: right,
                component: component,
            }
            if (tabsList.length === 0) {
                dynamicTabs = [...dynamicTabs, newTabObject]
            }
            const isTabExist = dynamicTabs.filter((tab) => {
                return tab.name === name
            })
            if (!(isTabExist && isTabExist.length > 0)) {
                dynamicTabs = [...dynamicTabs, newTabObject]
            }
            setTabsList(dynamicTabs)
            if (activeTabKey !== key) {
                setActiveTabKey(key)
            }
            type !== "isDispatched" && dispatch(MainBarActiveTabsAction({ 'TaskEncounter': { ActiveTabKey: key } }));
        }
    }

    return (
        <React.Fragment>
            <Nav className="rb-tabs bg-light-blue items-border ar_tabs-changes">
                {subCategoryItems && subCategoryItems.map((tab) => {
                    return (
                        <NavItem onClick={() => handleActiveTab(tab)}
                        >
                            <NavLink
                                className={`${activeTabKey === tab.key ? "py-2 active" : "py-2"} ${tab.right === false ? 'sidebar-disableed' : ''}`}
                            >{tab?.name}</NavLink>
                            {AccountReceivablesCountReducer[tab.name] == 0 ? null : <div class="counter heading mx-1">{AccountReceivablesCountReducer[tab.name]}</div>}
                        </NavItem>
                    )
                })}
            </Nav>
            <TaskInnerLeftContent activeTab={activeTabKey} dynamicTabs={tabsList} subCategItems={subCategoryItems} />
        </React.Fragment>
    )
}

export default TaskInnerLeftMenu
